export default __webpack_public_path__ + "static/media/main.12eb41c1.jpg";